import React from "react";
import styles from "../style.module.css"

export default function StudentTitle() {
  return (
    <div className={`${styles["row"]} ${styles.rowBox}`}>
      <div className={styles["text_row"]}>Student Name</div>
      <div className={`${styles["text_row"]} ${styles["text_margin"]}`} >WEEKLY MEASUREMENT (WPM)</div>
      <div className={styles["text_row"]}>PUSHUP (LPM)</div>
      <div className={styles["text_row"]}>NEAR POINT (CM)</div>
      {/* <div className={styles["text_row"]}></div> */}
    </div>
  );
}
